import React from "react";
import { VERTEX360_COPILOT_WORKSPACE_VIEWS } from "../constants/vertex360CopilotWorkspaceConstants";
import { useVertex360CopilotWorkspace } from "../hooks/useVertex360CopilotWorkspace";
import Vertex360CopilotSidebar from "./Vertex360CopilotSidebar";
import Vertex360CopilotChatsManagement from "./Vertex360CopilotChatsManagement";
import Vertex360CopilotWorkspaceChat from "./Vertex360CopilotWorkspaceChat";
import Vertex360CopilotDeleteConfirmModal from "./Vertex360CopilotDeleteConfirmModal";

const Vertex360CopilotWorkspaceLayout = () => {
  const {
    view,
    deleteConfirm,
    closeDeleteConfirm,
    confirmDeleteConversations,
  } = useVertex360CopilotWorkspace();

  return (
    <div className="copilot-workspace flex min-h-0 flex-1 overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm">
      <Vertex360CopilotSidebar />
      <main className="flex min-h-0 min-w-0 flex-1 flex-col">
        {view === VERTEX360_COPILOT_WORKSPACE_VIEWS.MANAGE ? (
          <Vertex360CopilotChatsManagement />
        ) : (
          <Vertex360CopilotWorkspaceChat />
        )}
      </main>

      <Vertex360CopilotDeleteConfirmModal
        isOpen={deleteConfirm.isOpen}
        variant={deleteConfirm.variant}
        conversations={deleteConfirm.conversations}
        confirming={deleteConfirm.isConfirming}
        errorMessage={deleteConfirm.error}
        onClose={closeDeleteConfirm}
        onConfirm={confirmDeleteConversations}
      />
    </div>
  );
};

export default Vertex360CopilotWorkspaceLayout;
